// extracted by mini-css-extract-plugin
export default {"fleetRisk":"fleetRiskMonth_fleetRisk__EYY25","searchBox":"fleetRiskMonth_searchBox__c3-tx"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"fleetRisk\":\"fleetRiskMonth_fleetRisk__EYY25\",\"searchBox\":\"fleetRiskMonth_searchBox__c3-tx\"}";
        // 1793842499228
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  